import type { RouteViewFactory } from '@/router/router'
import { loadIsChildProfile } from '@/header/childProfileNavGate'

// Lazy so KidsModeRestricted + its i18n bundle stay off the first-paint chunk
// that routes.tsx sits on.
const loadKidsModeRestricted = () => import('@/kidsMode/KidsModeRestricted')

const guard =
    (render: () => Promise<HTMLElement>) =>
    <T extends Record<string, string>>(factory: RouteViewFactory<T>): RouteViewFactory<T> =>
    async (params, query) => {
        if (await loadIsChildProfile()) return render()
        return factory(params, query)
    }

export const renderKidsModeRestricted = async () =>
    (await loadKidsModeRestricted()).KidsModeRestricted()

export const renderKidsModeRestrictedPage = async () =>
    (await loadKidsModeRestricted()).KidsModeRestrictedPage()

/**
 * Wraps a route factory so a confirmed child profile gets the KidsModeRestricted
 * message in place of the wrapped Podcasts/Audiobooks page, which keeps its own
 * page type in the page view (GH swaps the message into the page). Fails open: a
 * non-child, signed-out, or unresolved profile renders the real page (see
 * {@link loadIsChildProfile}), so a direct URL is never blocked for a non-child.
 */
export const kidsModeGuarded = guard(renderKidsModeRestricted)

/** {@link kidsModeGuarded} for a route whose GH page returns KidsModeRestrictedPage: it reports as not found. */
export const kidsModeRestrictedPageGuarded = guard(renderKidsModeRestrictedPage)
